import fooders from "./images/reactFooders.png";
import tracker from "./images/trackerLife.png";
import ecom from "./images/ecom.png";
import adhoc from "./images/adhoc.png";
import routerMan from "./images/routerMan.png";

export const featuredPortfolio = [
  {
    id: 1,
    title: "React Fooders",
    img: fooders,
    href: "https://reactfooders.netlify.app/",
    git: "https://github.com/Joshua-DaCosta/food-order",
  },
  {
    id: 2,
    title: "Tracker Life",
    img: tracker,
    href: "https://trackerlife.netlify.app/",
    git: "https://github.com/Joshua-DaCosta/course",
  },
  {
    id: 3,
    title: "Router Man",
    img: routerMan,
    href: "https://routerman.netlify.app/",
    git: "https://github.com/Joshua-DaCosta/router",
  },
  {
    id: 4,
    title: "E-commerce Divine Line",
    img: ecom,
    href: "https://divine-line.netlify.app/",
    git: "https://github.com/Joshua-DaCosta/ecom-store",
  },
  {
    id: 5,
    title: "Router Man",
    img: adhoc,
    href: "https://adocjd.netlify.app/",
    git: "https://github.com/Joshua-DaCosta/ADHOC-bootstrap-page",
  },
];
